module.exports = __webpack_public_path__ + "static/media/redTheme-girl.afba0016.svg";